import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
}, null, -1);
var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("polygon", {
  points: "12.95 10.707 13.657 10 8 4.343 6.586 5.757 10.828 10 6.586 14.243 8 15.657 12.95 10.707"
}, null, -1);
var _hoisted_6 = [_hoisted_5];
var _hoisted_7 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
}, null, -1);
var _hoisted_9 = [_hoisted_8];
var _hoisted_10 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 100 100"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7 0h86v100H57.108V88.418H42.892V100H7V0zm9 64h11v15H16V64zm57 0h11v15H73V64zm-19 0h11v15H54V64zm-19 0h11v15H35V64zM16 37h11v15H16V37zm57 0h11v15H73V37zm-19 0h11v15H54V37zm-19 0h11v15H35V37zM16 11h11v15H16V11zm57 0h11v15H73V11zm-19 0h11v15H54V11zm-19 0h11v15H35V11z"
}, null, -1);
var _hoisted_12 = [_hoisted_11];
var _hoisted_13 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 16H0V6h20v10h-4v4H4v-4zm2-4v6h8v-6H6zM4 0h12v5H4V0zM2 8v2h2V8H2zm4 0v2h2V8H6z"
}, null, -1);
var _hoisted_15 = [_hoisted_14];
var _hoisted_16 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
}, null, -1);
var _hoisted_18 = [_hoisted_17];
var _hoisted_19 = {
  key: 6,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};
var _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"
}, null, -1);
var _hoisted_21 = [_hoisted_20];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.name === 'cheveron-down' ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3)) : $props.name === 'cheveron-right' ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6)) : $props.name === 'dashboard' ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9)) : $props.name === 'office' ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12)) : $props.name === 'printer' ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_15)) : $props.name === 'trash' ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18)) : $props.name === 'users' ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true);
}